export default () => ({
  organizations: [],
  activeOrganization: ''
})
